import { Routes } from '@angular/router';
import { AuthGuard } from '@core/shared';

import { EmbeddedReportComponent } from './embedded-report/embedded-report.component';
import { ReportsComponent } from './reports.component';

export const EmbeddedReportRoutes: Routes = [
    {
        path: 'reports',
        component: ReportsComponent,
        children: [
            {
                path: 'embeddedreportpage/view/:id',
                canActivate: [AuthGuard],
                component: EmbeddedReportComponent,
                pathMatch: 'full',
                data: { title: 'Embedded Reports', isPreLogin: false, isDashboard: true }
            }
        ]
    }
];